import { keyBy, merge } from "lodash-es";
import { createSelector } from "@reduxjs/toolkit";

import { buildSingleItem, infoBlockItemMap } from "shared/utils";
import { API_ENDPOINTS } from "shared/constants";
import { IVenueBaseInfoBlock, IInfoBlockType } from "Venues/types";
import { dataSelector } from "./helpers";

const dataInfoBlockSelector = createSelector(dataSelector, data =>
  merge({}, data.venueInfoBlock, data.stageInfoBlock)
);

export const infoBlocksSelector = (infoBlockIds: string[]) =>
  createSelector(dataSelector, dataInfoBlockSelector, (data, infoBlocks) => {
    const infoBlocksData = infoBlockIds
      .map(id => {
        const infoBlock = infoBlocks?.[id];

        if (infoBlock) {
          const infoBlockData = buildSingleItem(infoBlock) as IVenueBaseInfoBlock;

          infoBlockItemMap.forEach(({ key, dataKey }) => {
            const infoBlockItems: any = infoBlockData[key]
              ?.map(({ id }: { id: string }) => {
                const path = API_ENDPOINTS.INFO_BLOCK_ITEM(id, dataKey);
                const item = data[dataKey]?.[path];
                if (item) {
                  return buildSingleItem(item);
                }
                return null;
              })
              .filter(item => !!item);

            infoBlockData[key] = infoBlockItems;
          });

          return infoBlockData;
        }

        return {} as IVenueBaseInfoBlock;
      })
      .filter(infoBlock => {
        return (
          infoBlock?.text !== null ||
          infoBlock?.contacts?.length ||
          infoBlock.places?.length ||
          infoBlock.files?.length ||
          infoBlock.images?.length
        );
      });

    return keyBy(infoBlocksData, "type") as {
      [key in IInfoBlockType]: IVenueBaseInfoBlock;
    };
  });
